<template>
  <ScrollArea
    class="scroll-null settings-css manage">
    <div
      v-if="!checkPermission('manage_settings') || forbidden" >
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Webhooks</p>
        </div>
      </h1>
      <Forbidden />
    </div>
    <div
      v-else
      class="settings--limit-width">
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Webhooks</p>
        </div>
      </h1>

      <Spinner
        v-if="!initialWebhookRequestFinished"
        class="mt-5"
        :size="20"
        :thickness="2" />

      <!-- <SettingsNote
        v-if="initialWebhookRequestFinished && webhooksExist"
        :icon="SBIconList.BROWSER"
        :text="`Learn more about how to use webhooks in our <a href='${webhookDocsUrl}' target='blank'>documentation</a>.`" /> -->

      <div class="sticky-top" >
        <!-- Search section -->
        <div
          v-if="initialWebhookRequestFinished && webhooksExist"
          class="flex space-between settings--box bottom-20 top-35">
          <SearchInput
            ref="searchInput"
            v-model="searchQuery"
            placeholder="Search webhooks..."
            @input="fetchWebhooksWithFilter" />
          <b-button
            class="flex center-all"
            @click="openNewWebhookModal">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.PLUS"
              :color="SBColors.blackPrimary"
              :size="8"/>
            <span>New</span>
          </b-button>
        </div>
      </div>

      <!--
        TODO  remove this table once it will not be needed - for now it is here for refference but we had to use the grid in theis case and we will probably switch to grid completelly.
              Stripe managed to get ellipsis inside table but they are probably recalculating table column widths and setting fixed walues.
              Check how they have done it and decide.
      -->
      <!-- Table -->
      <!-- <div class="settings--box">
        <b-table
          v-if="initialWebhookRequestFinished && webhooksExist"
          class="settings__table"
          :fields="fields"
          :items="webhooks"
          show-empty
          striped
          hover
          :busy="!webhooksLoaded" >
          <!-- Status column cell --
          <template #cell(status)="data">
            <span
              class="settings__pill"
              :class="{'settings__pill--blue': data.item.active, 'settings__pill--red': !data.item.active}" >
              {{ data.item.active ? 'Enabled' : 'Disabled' }}
            </span>
          </template>

          <!-- Url column cell --
          <template #cell(url)="data">
            <div>
              <p>{{ data.item.url }}</p>
            </div>
          </template>

          <!-- Events column cell --
          <template #cell(events)="data">
            <span
              v-if="data.item.selected_webhooks.length === 1"
              class="settings__pill">{{ data.item.selected_webhooks[0] }}</span>
            <div v-else>
              <span
                :id="`popover-${data.index}`"
                class="settings__pill" >
                {{ data.item.selected_webhooks.length }} events
              </span>
              <b-popover
                :target="`popover-${data.index}`"
                triggers="hover"
                placement="bottom" >
                <p
                  v-for="(webhook, index) in data.item.selected_webhooks"
                  :key="index"
                  class="mt-0"
                  :class="{'mt-3': index !== 0}" >
                  {{ webhook }}
                </p>
              </b-popover>
            </div>
          </template>

          <!-- Menu column cell --
          <template
            #cell(menu)="data"
            :ref="`boundryRef-${data.index}`">
            <div>
              <b-dropdown
                no-caret
                right
                toggle-class="settings__table-action"
                @click.stop.prevent
                @show="menuOpen[data.index] = true"
                @hide="menuOpen[data.index] = false">
                <template #button-content>
                  <span
                    :id="`popover-menu-${data.index}`"
                    class="menu-button flex center-all"
                    :class="{active: menuOpen[data.index]}" />
                </template>
                <b-dropdown-item @click="showSecretKey(data.item)">View secret key</b-dropdown-item>
                <b-dropdown-item @click="editWebhook(data.item)">Edit</b-dropdown-item>
                <b-dropdown-item @click="toggleWh(data.item)">{{ data.item.active ? 'Disable' : 'Enable' }}</b-dropdown-item>
                <b-dropdown-item @click="deleteWh(data.item)">Delete</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <!-- Busy table slot --
          <template #table-busy>
            <Spinner
              :size="24"
              :thickness="2" />
          </template>

          <!-- Empty filtered --
          <template #empty>
            <div class="flex center-all">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.MAGNIFIER"
                :color="SBColors.blackUltralight"
                :size="12"/>
              <p>We couldn’t find anything for <span class="strong">{{ searchQuery }}</span>.</p>
            </div>
          </template>
        </b-table>

        <InfoCard
          v-if="initialWebhookRequestFinished && !webhooksExist"
          :flat-icon="SBIconList.WEBHOOK"
          title="Add webhooks"
          description="Webhooks enable you to be notified in real-time about conversation and contact events without the need to constantly ping the API."
          action-text="Add webhook"
          @action="openNewWebhookModal" />
      </div> -->

      <div
        v-if="initialWebhookRequestFinished && webhooksExist"
        ref="tableGrid"
        class="table__grid clickable bottom-40">
        <span class="column-name sticky-top sticky-second">Status</span>
        <span class="column-name sticky-top sticky-second">URL</span>
        <span class="column-name sticky-top sticky-second">Events</span>
        <span class="column-name sticky-top sticky-second" />

        <span
          v-if="!webhooksLoaded"
          class="full-width table-count">
          <Spinner
            :size="20"
            :thickness="2" />
        </span>

        <span
          v-if="webhooksLoaded && webhooks.length"
          class="full-width table-count">WEBHOOKS ({{ webhooks.length }})</span>

        <span
          v-if="webhooksLoaded && !webhooks.length"
          class="full-width empty-results">
          <span class="flex center-all">
            <span class="emoji">😐</span>
            <p>We couldn’t find anything for <strong>{{ searchQuery }}</strong></p>
          </span>
        </span>

        <template
          v-for="(webhook, index) in (webhooksLoaded ? webhooks : [])" >
          <!-- Status column cell -->
          <div
            :key="`${index}-status`"
            :class="`hover-${index} flex flex-align-center`"
            @mouseleave="removeHover(index)"
            @mouseenter="addHover(index)"
            @click="showSecretKey(webhook)" >
            <span
              class="settings__pill"
              :class="{'settings__pill--blue': webhook.active, 'settings__pill--red': !webhook.active}" >
              {{ webhook.active ? 'Enabled' : 'Disabled' }}
            </span>
          </div>

          <!-- Url column cell -->
          <div
            :key="`${index}-url`"
            :class="`hover-${index} flex flex-align-center`"
            @mouseleave="removeHover(index)"
            @mouseenter="addHover(index)"
            @click="showSecretKey(webhook)" >
            <p
              class="ellipsis"
              :inner-html.prop="webhook.url | boldMatch(searchQuery)" />
          </div>

          <!-- Events column cell -->
          <div
            :key="`${index}-list`"
            :class="`hover-${index} flex flex-align-center`"
            @mouseleave="removeHover(index)"
            @mouseenter="addHover(index)"
            @click="showSecretKey(webhook)" >
            <span
              v-if="webhook.selected_webhooks.length === 1"
              class="settings__pill"
              :inner-html.prop="webhook.selected_webhooks[0] | boldMatch(searchQuery)" />
            <template
              v-else>
              <span
                :id="`popover2-${index}`"
                class="settings__pill" >
                {{ webhook.selected_webhooks.length }} events
              </span>
              <b-popover
                :target="`popover2-${index}`"
                triggers="hover"
                placement="bottom" >
                <p
                  v-for="(selectedWebhook, whIndex) in webhook.selected_webhooks"
                  :key="whIndex"
                  class="mt-0"
                  :class="{'mt-3': whIndex !== 0}"
                  :inner-html.prop="selectedWebhook | boldMatch(searchQuery)" />
              </b-popover>
            </template>
          </div>

          <!-- Menu column cell -->
          <div
            :key="`${index}-action`"
            :class="`hover-${index} flex flex-align-center`"
            @mouseleave="removeHover(index)"
            @mouseenter="addHover(index)"
            @click="showSecretKey(webhook)" >
            <b-dropdown
              no-caret
              right
              toggle-class="settings__table-action"
              @click.stop.prevent
              @show="menuOpen[index] = true"
              @hide="menuOpen[index] = false">
              <template #button-content>
                <span
                  :id="`popover-menu-${index}`"
                  class="menu-button flex center-all"
                  :class="{active: menuOpen[index]}" />
              </template>
              <b-dropdown-item @click.stop.prevent="showSecretKey(webhook)">View secret key</b-dropdown-item>
              <b-dropdown-item @click.stop.prevent="editWebhook(webhook)">Edit</b-dropdown-item>
              <b-dropdown-item @click.stop.prevent="toggleWh(webhook)">{{ webhook.active ? 'Disable' : 'Enable' }}</b-dropdown-item>
              <b-dropdown-item @click.stop.prevent="deleteWh(webhook)">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </div>

      <InfoCard
        v-if="initialWebhookRequestFinished && !webhooksExist"
        :flat-icon="SBIconList.WEBHOOK"
        title="Add webhooks"
        description="Webhooks enable you to be notified in real-time about conversation and contact events without the need to constantly ping the API."
        action-text="Add webhook"
        @action="openNewWebhookModal" />

      <WebhookModal
        ref="webhookModalRef"
        :business-id="business.id"
        @saved="fullReload()" />

      <SecretKeyModal
        ref="secretKeyModalRef" />
    </div>
  </ScrollArea>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ToasterMixin from '@/mixins/Toaster';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SettingsNote from '../partials/SettingsNote';
import Spinner from '@/components/common/Spinner';
import InfoCard from '@/components/common/InfoCard';
import SearchInput from '@/components/business/widgets/SearchInput';
import WebhookModal from '@/components/business/settings/api/modals/WebhookModal';
import SecretKeyModal from '@/components/business/settings/api/modals/SecretKey.modal';
import ScrollArea from '@/components/common/ScrollArea';
import NoPermissionMixin from '@/mixins/AccessPermission';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import CommonActions from '@/components/manage/CommonActions.mixin';

export default {
  name: 'WebhooksSettings',
  components: {
    SettingsNote,
    Spinner,
    SearchInput,
    InfoCard,
    SBIcon,
    WebhookModal,
    SecretKeyModal,
    ScrollArea,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
    UserPermissionsMixin,
    CommonActions,
  ],
  data() {
    return {
      menuOpen: [],
      fields: [
        {
          key: 'status',
          class: 'show-arrow',
        },
        {
          key: 'url',
          label: 'URL',
          class: 'data__url',
          thClass: 'data__url_th',
        },
        {
          key: 'events',
          class: 'show-arrow',
        },
        {
          key: 'menu',
          label: '',
          class: 'vertical-align-middle',
        },
      ],
      searchQuery: '',
      webhooksExist: false,
      initialWebhookRequestFinished: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      webhooks: 'webhook/webhooks',
      webhooksLoaded: 'webhook/webhooksLoaded',
      webhookDeleted: 'webhook/webhookDeleted',
      sendbeeDevelopersDocs: 'system/sendbeeDevelopersDocs',
      apiError: 'webhook/apiError',
      userPermissions: 'user/userPermissions',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
    },
    webhookDocsUrl() {
      return `${this.sendbeeDevelopersDocs}/#webhooks`;
    },
  },
  watch: {
    business() {
      if (this.checkPermission('manage_settings') && this.business.id) {
        this.initialWebhookRequestFinished = false;
        if (this.$refs.searchInput) {
          this.$refs.searchInput.clear();
        }
        this.fetchWebhooksWithFilter();
        this.fetchWebhookTypes(this.business.id);
      }
    },
    webhookDeleted(deleted) {
      if (deleted) {
        this.initialWebhookRequestFinished = false;
        this.fetchWebhooksWithFilter();
        this.showToaster('Webhook has been successfully deleted.', null, null, 'OK');
        this.$confirmPluginModal.close();
      }
    },
    webhooksLoaded() {
      if (this.webhooksLoaded) {
        if (!this.initialWebhookRequestFinished) {
          this.initialWebhookRequestFinished = true;
          this.webhooksExist = !!this.webhooks.length;
        }
      }
    },
    userPermissions() {
      if (this.checkPermission('manage_settings') && this.business.id) {
        this.initialWebhookRequestFinished = false;
        if (this.$refs.searchInput) {
          this.$refs.searchInput.clear();
        }
        this.fetchWebhooksWithFilter();
        this.fetchWebhookTypes(this.business.id);
      }
    },
  },
  mounted() {
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if (this.checkPermission('manage_settings') && this.business.id) {
      this.fetchWebhooksWithFilter();
      this.fetchWebhookTypes(this.business.id);
    }
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      fetchWebhooks: 'webhook/fetchWebhooks',
      fetchWebhookTypes: 'webhook/fetchWebhookTypes',
      deleteWebhook: 'webhook/deleteWebhook',
      updateWebhook: 'webhook/updateWebhook',
      updateWebhookState: 'webhook/updateWebhookState',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    deleteWh(webhook) {
      this.$confirmPluginModal.show({
        title: 'Delete webhook',
        message: 'Are you sure you want to delete this webhook? After deleting this endpoint, no future webhook will be sent to this URL.',
        confirmButtonText: 'Delete',
        buttonVariant: 'RED',
        confirmCallback: () => {
          this.deleteWebhook({
            merchant_id: this.business.id,
            webhook_id: webhook.id,
          });
        },
      });
    },
    editWebhook(webhook) {
      this.$refs.webhookModalRef.show(webhook);
    },
    fetchWebhooksWithFilter() {
      const data = {};

      if (this.searchQuery.toLowerCase() === 'enabled') {
        data.state = true;
      } else if (this.searchQuery.toLowerCase() === 'disabled') {
        data.state = false;
      } else if (this.searchQuery !== '') {
        data.url = this.searchQuery;
        data.type = this.searchQuery;
        data.operator = 'or'; // TODO this is hardcoded until we decide if we will have a more complex filter other than just one input field. If "and" is used here than filter will return only the results that have a keyword both in url and the type
      }

      this.fetchWebhooks({
        businessId: this.business.id,
        data,
      });
    },
    openNewWebhookModal() {
      this.$refs.webhookModalRef.show();
    },
    showSecretKey(webhook) {
      this.$refs.secretKeyModalRef.show(webhook);
    },
    toggleWh(webhook) {
      const data = {
        active: !webhook.active,
      };
      this.updateWebhookState({
        merchant_id: this.business.id,
        webhook_id: webhook.id,
        data,
      }).then(() => {
        webhook.active = !webhook.active;
        this.showToaster(webhook.active ? 'Webhook has been successfully enabled.' : 'Webhook has been successfully disabled.', null, null, 'OK');
      });
    },
    addHover(index) {
      const cells = this.$refs.tableGrid.getElementsByClassName(`hover-${index}`);

      for (let index = 0; index < cells.length; index++) {
        const cell = cells[index];
        if (index === 0) {
          cell.classList.add('first');
        }
        cell.classList.add('hover-grid');
        if (index === cells.length - 1) {
          cell.classList.add('last');
        }
      }
    },
    removeHover(index) {
      const cells = this.$refs.tableGrid.getElementsByClassName(`hover-${index}`);

      for (let index = 0; index < cells.length; index++) {
        const cell = cells[index];
        cell.classList.remove('hover-grid');
        cell.classList.remove('last');
      }
    },
    fullReload() {
      this.initialWebhookRequestFinished = false;
      this.fetchWebhooksWithFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-null {
  margin: -35px 0 -35px 0;
  height: calc(100% + 35px);

  .settings__title {
    padding-top: 70px;
    margin-top: 0;
  }
}

::v-deep .data__url p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .loader {
  margin-top: 29px;
}
</style>
